import { LogoLoop } from "@/components/LogoLoop";

import bitbankPng from "./assets/bitbank.png";
import dentsuPng from "./assets/dentsu.png";
import jpxPng from "./assets/jpx.png";
import sbpsPng from "./assets/sbps.png";
import septeniPng from "./assets/septeni.png";

const achievementLogos = [
  { src: bitbankPng, alt: "ビットバンク", title: "ビットバンク" },
  { src: dentsuPng, alt: "電通", title: "電通" },
  { src: jpxPng, alt: "日本取引所グループ", title: "日本取引所グループ（JPX）" },
  { src: sbpsPng, alt: "SBPS", title: "SBPS" },
  { src: septeniPng, alt: "セプテーニ・ホールディングス", title: "セプテーニ・ホールディングス" },
];

export function Achievement() {
  return (
    <div
      className="relative w-full overflow-hidden py-6"
      style={{ minHeight: "80px" }}
    >
      <LogoLoop
        logos={achievementLogos}
        speed={80}
        direction="left"
        logoHeight={40}
        gap={48}
        hoverSpeed={0}
        fadeOut
        fadeOutColor="var(--background, #fff)"
        ariaLabel="取引実績・導入企業"
      />
    </div>
  );
}
